export default __webpack_public_path__ + "static/media/default.82331cb5.jpg";